import { BlastEvent, SimulationConfig } from '@/types';
import { drawBlastShape } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const PrismSplitAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  const colors = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff'];
  for (let i = 0; i < colors.length; i++) {
    ctx.strokeStyle = colors[i];
    const d = progress * 60 * (i + 1);
    drawBlastShape(ctx, e, e.maxRadius + d);
    ctx.lineWidth = 4 * (1 - progress); ctx.stroke();
  }
};

registerBlastAnimation('PRISM_SPLIT', PrismSplitAnimation);
